import React from "react";

function KeepUpIcon() {
  return (
    <svg
      width="41"
      height="41"
      viewBox="0 0 41 41"
      fill="#fff"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_0_1037"
        style={{maskType:"alpha"}}
        maskUnits="userSpaceOnUse"
        x="3"
        y="7"
        width="35"
        height="27"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.32178 7.89291H37.6779V33.6611H3.32178V7.89291Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_0_1037)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.5323 12.1064C21.4029 13.0328 23.2274 13.9364 25.0618 14.8449C25.2055 14.3299 25.2915 13.8342 25.1321 13.3437C24.9892 12.904 24.821 12.4683 24.6185 12.053C24.0502 10.8878 22.9027 10.4987 21.7264 11.0526C21.2002 11.3003 20.6774 11.5554 20.1531 11.8073C19.9608 11.8997 19.7687 11.9925 19.5323 12.1064ZM8.17666 11.5668C8.16911 11.2457 8.06136 10.9607 7.83991 10.7298C7.04496 9.90069 6.25466 9.06674 5.44291 8.25434C4.94816 7.75919 4.19471 7.78199 3.68796 8.26634C3.23021 8.70389 3.19371 9.45619 3.62316 9.96604C3.83706 10.22 4.07926 10.4504 4.31191 10.6884C4.87056 11.2598 5.42881 11.8316 5.99176 12.3988C6.38431 12.7942 6.85116 12.9321 7.38196 12.7317C7.87001 12.5475 8.17831 12.0757 8.17666 11.5668ZM32.7648 11.5649C32.7686 12.0574 33.0612 12.5087 33.5469 12.7157C34.0282 12.9209 34.4832 12.8375 34.8671 12.4864C35.2232 12.1607 35.5581 11.8115 35.8989 11.4693C36.3983 10.9678 36.9126 10.4795 37.387 9.95529C37.8362 9.45894 37.7504 8.72134 37.2317 8.23084C36.7937 7.81659 36.023 7.79324 35.5905 8.21474C34.7496 9.03419 33.9246 9.87004 33.0967 10.7028C32.8623 10.9386 32.7635 11.2343 32.7648 11.5649ZM23.3235 15.7931C23.0361 15.6511 22.7997 15.5335 22.5626 15.4172C20.3896 14.3512 18.2177 13.2829 16.0429 12.2207C15.08 11.7505 14.0783 11.9145 13.4725 12.7065C13.1697 13.1025 12.9433 13.5748 12.7634 14.0437C12.2408 15.406 12.8582 16.9511 14.1577 17.614C15.0098 18.0487 15.8688 18.47 16.7194 18.9074C16.8567 18.978 16.9571 18.9658 17.0861 18.9008C17.933 18.4742 18.7839 18.0556 19.6327 17.633C20.8456 17.0292 22.0578 16.4241 23.3235 15.7931ZM10.4892 33.6611C10.7376 33.6378 10.9861 33.6151 11.2344 33.5908C11.2839 33.5859 11.3331 33.5764 11.3819 33.5663C12.9686 33.2374 14.1122 32.3236 14.796 30.8734C15.5618 29.2494 16.3005 27.6114 17.0012 25.9585C17.8727 23.9028 17.1458 21.402 15.2643 20.1996C14.3189 19.5953 13.258 19.1656 12.2308 18.6978C11.7858 18.4952 11.2883 18.5189 10.8071 18.6277C9.84001 18.8463 9.16761 19.4202 8.73091 20.3054C8.06876 21.6477 7.38621 22.9799 6.71406 24.3173C6.04571 25.6472 5.34996 26.9644 4.72066 28.3127C4.07371 29.6989 4.69416 31.3475 6.06171 32.0312C6.76831 32.3844 7.47936 32.7288 8.18411 33.0855C8.90946 33.4527 9.67166 33.6588 10.4892 33.6611Z"
          fill="white"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.02835 40.7923C4.80665 40.6854 4.5643 40.6074 4.36695 40.4664C3.5995 39.9181 3.4286 38.8717 4.01295 38.1281C4.97505 36.9037 5.9698 35.705 6.946 34.4916C7.0416 34.3728 7.1212 34.3784 7.2411 34.443C8.0862 34.898 8.98105 35.1781 9.9433 35.2633C11.093 35.3652 12.1851 35.1726 13.2184 34.6763C14.7128 33.9585 15.7645 32.811 16.4442 31.3036C17.1142 29.8178 17.826 28.3505 18.4815 26.8585C19.4402 24.6765 19.2709 22.5665 17.9854 20.5526C17.9585 20.5105 17.9325 20.468 17.8961 20.4097C17.9418 20.379 17.9833 20.3434 18.0309 20.3202C21.1122 18.8203 24.1934 17.3199 27.2789 15.8286C27.3867 15.7764 27.5551 15.7742 27.6674 15.8188C28.3489 16.0897 28.8253 16.5871 29.145 17.2377C30.5752 20.1491 32.0124 23.0572 33.4275 25.9759C34.1336 27.4321 33.5126 29.1367 32.0514 29.85C28.5008 31.5834 24.9489 33.3142 21.4001 35.0515C21.2644 35.1179 21.1332 35.2229 21.0392 35.3412C19.8209 36.8727 18.6052 38.4062 17.3997 39.9478C17.0653 40.3755 16.6793 40.7004 16.1297 40.7923H5.02835Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.8304 40.7923C24.227 40.698 23.8375 40.312 23.4854 39.8483C22.8509 39.0127 22.1938 38.1943 21.5466 37.3684C21.4911 37.2974 21.4394 37.2234 21.3696 37.1288C22.0125 36.8212 22.6392 36.5198 23.2672 36.2214C26.1525 34.8506 29.0389 33.4825 31.9216 32.1064C32.1015 32.0205 32.1914 32.0497 32.3099 32.2025C33.8049 34.1312 35.281 36.0755 36.8177 37.9706C37.6343 38.9777 37.2048 40.5016 35.9199 40.762C35.9057 40.7649 35.8944 40.7819 35.8817 40.7923H24.8304Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.7301 0.792305C20.8766 0.866255 21.0348 0.923605 21.1673 1.01725C21.5381 1.2792 21.7302 1.64255 21.7301 2.1016C21.7298 3.17625 21.7353 4.25091 21.7282 5.32545C21.7233 6.0663 21.1571 6.64235 20.4656 6.6298C19.771 6.6172 19.2345 6.0553 19.2312 5.3234C19.2265 4.2821 19.2292 3.2408 19.2302 2.1995C19.2309 1.4799 19.4996 1.0943 20.1738 0.836555C20.1951 0.828455 20.2114 0.807355 20.23 0.792305H20.7301Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.489 33.6611C9.67145 33.6588 8.9093 33.4527 8.1839 33.0855C7.47915 32.7288 6.7681 32.3845 6.06155 32.0312C4.69395 31.3475 4.0735 29.6989 4.7205 28.3127C5.34975 26.9645 6.04555 25.6472 6.7139 24.3173C7.386 22.9799 8.06855 21.6477 8.73075 20.3054C9.1674 19.4202 9.8398 18.8464 10.8069 18.6277C11.2881 18.5189 11.7856 18.4952 12.2306 18.6979C13.2578 19.1656 14.3186 19.5953 15.2641 20.1996C17.1455 21.4021 17.8725 23.9029 17.001 25.9585C16.3003 27.6114 15.5615 29.2494 14.7958 30.8734C14.112 32.3237 12.9684 33.2374 11.3817 33.5663C11.3329 33.5764 11.2837 33.5859 11.2342 33.5908C10.9858 33.6151 10.7374 33.6378 10.489 33.6611Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.3233 15.7931C22.0576 16.4242 20.8454 17.0292 19.6326 17.633C18.7837 18.0556 17.9329 18.4743 17.086 18.9008C16.957 18.9658 16.8565 18.978 16.7193 18.9074C15.8686 18.47 15.0097 18.0487 14.1575 17.614C12.858 16.9512 12.2406 15.406 12.7633 14.0437C12.9432 13.5748 13.1695 13.1025 13.4724 12.7065C14.0781 11.9146 15.0799 11.7505 16.0427 12.2208C18.2176 13.283 20.3895 14.3513 22.5625 15.4173C22.7996 15.5336 23.036 15.6511 23.3233 15.7931Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.7647 11.5649C32.7633 11.2343 32.8621 10.9386 33.0966 10.7028C33.9244 9.87007 34.7494 9.03417 35.5903 8.21472C36.0228 7.79322 36.7935 7.81662 37.2315 8.23082C37.7502 8.72132 37.8361 9.45892 37.3868 9.95527C36.9124 10.4795 36.3981 10.9678 35.8987 11.4693C35.5579 11.8115 35.2231 12.1607 34.8669 12.4864C34.483 12.8375 34.028 12.9209 33.5467 12.7158C33.061 12.5088 32.7685 12.0575 32.7647 11.5649Z"
        fill="white"
      />
      <mask
        id="mask1_0_1037"
        style={{maskType:"alpha"}}
        maskUnits="userSpaceOnUse"
        x="3"
        y="7"
        width="6"
        height="6"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.32178 7.89293H8.17631V12.823H3.32178V7.89293Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_0_1037)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.17631 11.5669C8.17831 12.0757 7.87001 12.5476 7.38196 12.7318C6.85116 12.9321 6.38431 12.7943 5.99176 12.3988C5.42881 11.8317 4.87056 11.2598 4.31191 10.6884C4.07926 10.4505 3.83706 10.22 3.62316 9.96601C3.19371 9.45621 3.23021 8.70386 3.68796 8.26636C4.19471 7.78201 4.94816 7.75921 5.44291 8.25431C6.25466 9.06676 7.04496 9.90071 7.83991 10.7298C8.06136 10.9608 8.16911 11.2458 8.17631 11.5669Z"
          fill="white"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.5322 12.1064C19.7686 11.9925 19.9607 11.8997 20.153 11.8073C20.6773 11.5554 21.2001 11.3003 21.7264 11.0526C22.9026 10.4987 24.0501 10.8878 24.6184 12.053C24.821 12.4683 24.9892 12.904 25.1321 13.3437C25.2914 13.8342 25.2055 14.3299 25.0618 14.8449C23.2273 13.9364 21.4028 13.0328 19.5322 12.1064Z"
        fill="white"
      />
    </svg>
  );
}

export default KeepUpIcon;
